import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
import BreadCrumb from '../../common/breadcrumb/breadCrumb';
import { db } from '../../../../firebase';
import { getDocs, collection, query, limit } from 'firebase/firestore';

const Categories = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch limited services from Firestore
  const fetchServices = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, 'services'), limit(12)); // Fetch only 12 documents
      const servicesSnapshot = await getDocs(q);
      const servicesList = servicesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setServices(servicesList);
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <>
      {/* Breadcrumb */}
      <BreadCrumb title="Categories" item1="Categories" />
      {/* /Breadcrumb */}

      <div className="page-wrapper">
        <div className="content">
          <div className="container">
            {loading ? (
              <div className="text-center">Loading...</div>
            ) : (
              <div className="row justify-content-center align-items-center">
                {services.map((service) => (
                  <div className="col-lg-3 col-md-6" key={service.id}>
                    <div
                      className="category card wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="card-body">
                        <div className="feature-icon d-flex justify-content-center align-items-center mb-2">
                          <span className="rounded-pill d-flex justify-content-center align-items-center p-3">
                            <img
                              src={service.icon || 'assets/img/icons/placeholder.svg'}
                              className="img-fluid"
                              alt={service.lbl || 'Service Icon'}
                            />
                          </span>
                        </div>
                        <h5 className="text-center">{service.lbl || 'Unnamed Service'}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Categories;
